<script lang="ts" setup>
defineProps<{
  is: string;
}>();

const { locale } = useI18n();
</script>

<template>
  <component :is="is">
    <LazyPaymentYooMoney v-if="(locale as string) === 'ru'">
      <slot />
    </LazyPaymentYooMoney>
    <LazyPaymentStripe v-else>
      <slot />
    </LazyPaymentStripe>
  </component>
</template>
